import { useState } from "react";
import FacetIcon from "./FacetIcon";

const TimeFacet = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleFilterClick = (val) => {
    props.filtersHandler(props.id, val);
  };
  const checkIfActive = (d) => {
    if (!props.selections[props.id]) {
      return false;
    } else {
      return props.selections[props.id].includes(d);
    }
  };
  return (
    <div className="w-full border-b-[1px] border-b-black border-dotted ">
      <div className="w-full flex flex-row justify-between items-center py-5">
        <span className="font-bold uppercase text-filter-title whitespace-nowrap">{props.label}</span>
        <span
          className={`transition-all duration-400 cursor-pointer ${
            isOpen ? "-rotate-45" : ""
          }`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <FacetIcon />
        </span>
      </div>
      {isOpen ? (
        <div className="flex flex-col items-start justif-start uppercase max-h-[150px] overflow-y-auto pb-2.5">
          {props.facetValues.map((f) => (
            <div
              className={`cursor-pointer hover:opacity-50 text-left ${
                checkIfActive(f.value) ? "text-primary font-bold" : "text-grey"
              }`}
              onClick={() => handleFilterClick(f.value)}
              key={`${props.isBefore ? "b-" : "a-"}${f.value}`}
            >
              {f.label}
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default TimeFacet;
